import React, { ReactNode } from 'react';
import { ToastId, toast } from 'react-toastify';

import Component from './component';

/**
 ToastId used to prevent duplicate notifications
 https://fkhadra.github.io/react-toastify/prevent-duplicate/#check-if-a-toast-is-already-displayed
 */

let notificationErrorId: ToastId;
let notificationSuccessId: ToastId;
let notificationInfoId: ToastId;

export const notificationError = (notification: ReactNode, options = {}) => {
  if (!toast.isActive(notificationErrorId)) {
    notificationErrorId = toast.error(
      <Component type={toast.TYPE.ERROR} reason={notification} />,
      options
    );
  }
  return notificationErrorId;
};

export const notificationSuccess = (notification: ReactNode, options = {}) => {
  if (!toast.isActive(notificationSuccessId)) {
    notificationSuccessId = toast.success(
      <Component type={toast.TYPE.SUCCESS} reason={notification} />,
      options
    );
  }
  return notificationSuccessId;
};

export const notificationInfo = (notification: ReactNode, options = {}) => {
  if (!toast.isActive(notificationInfoId)) {
    notificationInfoId = toast.info(
      <Component type={toast.TYPE.INFO} reason={notification} />,
      options
    );
  }
  return notificationInfoId;
};
